// GENERATED FILE, DO NOT MANUALLY EDIT
import { html } from '@horizon/base';
import { HznIconBase } from '../../icon/icon-base.js';
import './types.js';
/**
 *
 * @tag hzn-icon-image
 * @tagname hzn-icon-image
 * @summary An individual icon for Horizon
 */
export class HznIconImage extends HznIconBase {
    render() {
        return html `<div class="hzn-icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5ZM5 5H7H17H19V7V16.9984C18.9998 16.8461 18.9648 16.6934 18.8944 16.5528L15.8944 10.5528C15.7454 10.2548 15.4577 10.0505 15.1272 10.0081C14.7967 9.96573 14.4668 10.0907 14.2474 10.3415L11.5185 13.4602L9.76822 11.3598C9.56087 11.111 9.24585 10.978 8.92292 11.003C8.59999 11.0279 8.30915 11.2078 8.14251 11.4855L5.14251 16.4855C5.04767 16.6436 5.00008 16.8215 5 16.9996V7V5ZM5 19V17.0005C5.00008 17.1701 5.04327 17.3399 5.1298 17.4927C5.30731 17.8062 5.63973 18 6 18H18C18.3466 18 18.6684 17.8205 18.8507 17.5257C18.9496 17.3656 18.9997 17.1838 19 17.0015V19H17H7H5ZM12.2526 15.6585L14.7717 12.7795L16.382 16H11.5007C11.7886 15.9998 12.0627 15.8755 12.2526 15.6585ZM10.7318 15.6402L9.13312 13.7218L7.76619 16H11.4994L11.488 15.9999C11.1954 15.9964 10.9191 15.8649 10.7318 15.6402Z" fill="currentColor"></path>
</svg></div>`;
    }
}
//# sourceMappingURL=image.js.map